import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';

export const useDrugTabContent = () => {
  const {
    FactsStore: {
      setIsNdcTableLoading,
      handleFetchNDCInfo,
      handleFetchTargetMarketShareForSelectedGFC,
      drugConceptsList,
      currentTabIndex,
    },
  } = useStore();

  useEffect(() => {
    if (currentTabIndex === -1) return;
    const controller = new AbortController();
    const signal = controller.signal;
    setIsNdcTableLoading(true);
    handleFetchNDCInfo('', signal);
    handleFetchTargetMarketShareForSelectedGFC(signal);
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run when tab changes
  }, [currentTabIndex]);

  return { drugConceptsList, currentTabIndex };
};
